import axios from 'axios';
import { useState } from 'react';

function BookCreateModal({ setIsModalOpen }) {
  const [formData, setFormData] = useState({
    title: '',
    author_name: '',
    category_id: 1,
    current_price: '',
    regular_price: '',
    seo_description: '',
    description: '',
  });

  const [imageFile, setImageFile] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handlePdfChange = (e) => {
    setPdfFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    const form = new FormData();

    for (const key in formData) {
      form.append(key, formData[key]);
    }

    if (imageFile) form.append('image', imageFile);
    if (pdfFile) form.append('pdf', pdfFile);

    setIsLoading(true);
    try {
      await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/books`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      alert('Book created successfully!');
      setIsModalOpen(false);
    } catch (error) {
      if (error.response?.data?.message) {
        alert(error.response.data.message);
      } else {
        alert('Failed to create book.');
      }
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-md p-6 w-[90%] max-w-md relative overflow-y-auto max-h-[90vh]">
        <h3 className="text-xl font-semibold mb-4">Create Book</h3>

        <input
          type="text"
          name="title"
          placeholder="Title"
          value={formData.title}
          onChange={handleInputChange}
          className="w-full border border-gray-300 p-2 rounded mb-3"
        />
        <input
          type="text"
          name="author_name"
          placeholder="Author Name"
          value={formData.author_name}
          onChange={handleInputChange}
          className="w-full border border-gray-300 p-2 rounded mb-3"
        />
        <input
          type="number"
          name="current_price"
          placeholder="Current Price"
          value={formData.current_price}
          onChange={handleInputChange}
          className="w-full border border-gray-300 p-2 rounded mb-3"
        />
        <input
          type="number"
          name="regular_price"
          placeholder="Regular Price"
          value={formData.regular_price}
          onChange={handleInputChange}
          className="w-full border border-gray-300 p-2 rounded mb-3"
        />
        <input
          type="text"
          name="seo_description"
          placeholder="SEO Description"
          value={formData.seo_description}
          onChange={handleInputChange}
          className="w-full border border-gray-300 p-2 rounded mb-3"
        />

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Upload Image
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="block w-full text-sm text-gray-500 file:py-2 file:px-4 file:border-0 file:bg-[#22BEFF] file:text-white file:rounded cursor-pointer"
          />
          {imagePreview && (
            <img
              src={imagePreview}
              alt="Preview"
              className="mt-4 w-full h-auto rounded border"
            />
          )}
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Upload PDF
          </label>
          <input
            type="file"
            accept="application/pdf"
            onChange={handlePdfChange}
            className="block w-full text-sm text-gray-500 file:py-2 file:px-4 file:border-0 file:bg-[#22BEFF] file:text-white file:rounded cursor-pointer"
          />
        </div>

        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={() => setIsModalOpen(false)}
            className="px-4 py-2 bg-gray-300 rounded"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-[#22BEFF] text-white rounded flex items-center justify-center"
            disabled={isLoading}
          >
            {isLoading && (
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            )}
            {isLoading ? 'Saving...' : 'Save'}
          </button>
        </div>

        <button
          onClick={() => setIsModalOpen(false)}
          className="absolute top-2 right-2 text-black hover:text-red-500 text-xl"
          disabled={isLoading}
        >
          &times;
        </button>
      </div>
    </div>
  );
}

export default BookCreateModal;
